import { api } from "apiServer"
import CardLeague from "components/CardLeague"
import { Layout } from "components/common"
import { trackGA } from "lib/func"
import { useEffect } from "react"
import { Fragment } from "react"
import SportType from "utils/SportType"
function Component({ lists }) {
  useEffect(() => {
    trackGA("LEAGUE", "LEAGUE")
  }, [])
  return (
    <>
      <section className="py-12 max-w-screen-xl mx-auto px-4 md:px-8 lg:px-12 2xl:px-0">
        <h2 className="relative mb-4 text-sm md:text-lg lg:text-2xl font-bold text-dark-100 leading-10">GIẢI ĐẤU</h2>
        <div>
          {lists?.length > 0 &&
            lists?.map((item, index) => {
              const { list, sport_type } = item
              return (
                <Fragment key={index}>
                  <section className="max-w-screen-xl mx-auto md:px-12 2xl:px-0">
                    <h2 className="relative mb-4 text-sm md:text-base lg:text-xl font-bold text-dark-100">
                      <div className=" text-dark-300 font-semibold mb-2">
                        {sport_type === SportType.SOCCER && "Bóng đá"}
                      </div>
                      <div className=" text-dark-300 font-semibold mb-2">
                        {sport_type === SportType.TENNIS && "Tennis"}
                      </div>
                      <div className=" text-dark-300 font-semibold mb-2">
                        {sport_type === SportType.BASKETBALL && "Bóng rổ"}
                      </div>
                      <div className=" text-dark-300 font-semibold mb-2">{sport_type === SportType.GOLF && "GOLF"}</div>
                      <div className=" text-dark-300 font-semibold mb-2">
                        {sport_type === SportType.VOLLEYBALL && "Bóng chuyền"}
                      </div>
                      <div className=" text-dark-300 font-semibold mb-2">
                        {sport_type === SportType.BOXING && "Boxing"}
                      </div>
                    </h2>
                    <div className="mb-8 grid grid-cols-5 sm:grid-cols-6 md:grid-cols-6 lg:grid-cols-7 xl:grid-cols-8 2xl:grid-cols-10 md:gap-6 gap-3">
                      {list?.length > 0 &&
                        list?.map((value, index) => {
                          return (
                            <Fragment key={index}>
                              <CardLeague {...value} />
                            </Fragment>
                          )
                        })}
                    </div>
                  </section>
                </Fragment>
              )
            })}
        </div>
      </section>
    </>
  )
}

export default Component
Component.Layout = Layout

export async function getServerSideProps({ req, res }) {
  res.setHeader("Cache-Control", "public, s-maxage=10, stale-while-revalidate=29")
  let lists = []
  const { cookies } = req
  try {
    const { data, success } = await api.getSeemoreLeagues(cookies?.accessToken)
    if (success) lists = data
  } catch (error) {
    console.log(error.response)
  }
  return { props: { lists } }
}
